/**
 * Firebase configuration and service initialization.
 * All Firebase services (Auth, Realtime Database, Storage) are
 * initialized here and exported as singletons for use across the app.
 */

import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getDatabase } from 'firebase/database';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

const app = initializeApp(firebaseConfig);

/** Firebase Authentication instance. */
export const auth = getAuth(app);

/** Firebase Realtime Database instance. */
export const db = getDatabase(app);

/** Firebase Cloud Storage instance. */
export const storage = getStorage(app);

export default app;
